import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

class Readmore
{
    className: string;
    readmore: HTMLElement;
    contentContainer: HTMLElement;
    viewHeight: number;
    fullHeight: number;
    buttonOpenText: string = '<span class="text-uppercase"><ion-icon class="remove-circle-outline" name="remove-circle-outline"></ion-icon> Read Less</span>';
    buttonClosedText: string = '<span class="text-uppercase"><ion-icon class="add-circle-outline" name="add-circle-outline"></ion-icon> Read More</span>';
    readmoreButton: HTMLButtonElement;

    constructor(className: string)
    {
        // used to find the correct readmore on page
        this.className = className;
        this.init();
    }

    init()
    {
        /* without ids use class init foreach 
        // this could be a global querySelectorAll to find all readmores but lets just init by id
        const readmores = document.querySelectorAll('.readmore-container');
        readmores.forEach(function(readmore: HTMLElement)
        {

        });
        */
        this.readmore = document.querySelector(`.${this.className}[data-readmore="true"]`);

        if (this.readmore) {
            this.contentContainer = this.readmore.querySelector('.content-container') as HTMLElement;
            this.fullHeight = this.contentContainer.offsetHeight;
            this.displayView();
        }
    }

    private displayView()
    {
        const ps: NodeListOf<HTMLParagraphElement> = this.readmore.querySelectorAll('p');
        if (ps)
        {
            // hide logic, TODO: use data-readmore-p="x" to hide extra
            if (ps.length > 2){
                //set collapsed container height based on amount of paragraphs
                this.viewHeight = (ps[0].offsetHeight + ps[1].offsetHeight) + 30;
            } else if (ps.length > 1) {
                this.viewHeight = ps[0].offsetHeight + 30;
            }
            this.contentContainer.style.height = `${this.viewHeight}px`;
            this.contentContainer.classList.add('collapsed');

            // append the new button to document
            this.createButton();
            this.readmore.append(this.readmoreButton);
        }
    }

    private createButton(): HTMLButtonElement
    {
        const self = this;
        // create readmore toggle button
        this.readmoreButton = document.createElement("button");
        this.readmoreButton.classList.add('btn');
        this.readmoreButton.classList.add('btn-outline-primary');
        this.readmoreButton.classList.add('readmore');
        this.readmoreButton.innerHTML = this.buttonClosedText;

        //readmore toggle button click event to toggle height
        this.readmoreButton.addEventListener('click', function(e)
        {
            self.toggle();
        });
        return this.readmoreButton;
    }

    toggle()
    {
        if (this.contentContainer.classList.contains('collapsed')){
            this.contentContainer.classList.remove('collapsed');
            this.contentContainer.style.height = `${this.fullHeight}px`;
            this.readmoreButton.innerHTML = this.buttonOpenText;
        } else {
            this.contentContainer.classList.add('collapsed');
            this.contentContainer.style.height = `${this.viewHeight}px`;
            this.readmoreButton.innerHTML = this.buttonClosedText;
        }
    }
}

export default Readmore;